import {
  Icon,
  IconArrowsExchange,
  IconBuildingBank,
  IconCalendar,
  IconChecklist,
  IconFile,
  IconFileSpreadsheet,
  IconProps,
  IconUser,
  IconWallet,
} from '@tabler/icons-react';
import { ForwardRefExoticComponent, RefAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { CommunityFeedItemDto } from 'src/Services/API/generated';

export type CommunityFeedItemTag = {
  label: string;
  icon: ForwardRefExoticComponent<IconProps & RefAttributes<Icon>>;
};

export function useCommunityFeedItemToTag(
  feedItem: CommunityFeedItemDto
): CommunityFeedItemTag | null {
  const { t } = useTranslation();

  if (feedItem.type.startsWith('INSTRUCTION')) {
    return { label: t('community.badge.instruction', 'Consigne'), icon: IconChecklist };
  }

  if (feedItem.type.startsWith('CHECKLIST')) {
    return { label: t('community.badge.checklist', 'Checklist'), icon: IconChecklist };
  }

  if (feedItem.type.startsWith('PRACTICAL')) {
    return {
      label: t('community.badge.practicalInformation', 'Information pratique'),
      icon: IconFileSpreadsheet,
    };
  }

  if (feedItem.type.startsWith('EXPENSE')) {
    return { label: t('community.badge.budget', 'Budget'), icon: IconWallet };
  }

  if (feedItem.type.startsWith('CONTACT')) {
    return { label: t('community.badge.contact', 'Contact'), icon: IconUser };
  }

  if (feedItem.type.startsWith('ASSET_MEMBER')) {
    return { label: t('community.badge.family', 'Famille'), icon: IconUser };
  }

  if (feedItem.type.startsWith('EVENT')) {
    return { label: t('community.badge.event', 'Planning'), icon: IconCalendar };
  }

  if (feedItem.type.startsWith('DOCUMENT')) {
    return { label: t('community.badge.document', 'Document'), icon: IconFile };
  }

  if (feedItem.type.startsWith('PROJECT')) {
    return { label: t('community.badge.project', 'Projet'), icon: IconFileSpreadsheet };
  }

  if (feedItem.type.startsWith('BANK_ACCOUNT')) {
    return { label: t('community.badge.bankAccount', 'Budget'), icon: IconBuildingBank };
  }

  if (feedItem.type.startsWith('MONEY_TRANSFER')) {
    return { label: t('community.badge.transfer', 'Budget'), icon: IconArrowsExchange };
  }

  return null;
}
